<template>
  <div class="mall-collect">
    <div class="top">
      <div class="tabs">
        <div
          class="tab-item"
          :class="[curr_tab == 1 ? 'active' : '']"
          @click="onTabClick(1)"
        >
          商品收藏
        </div>
        <div
          v-if="false"
          class="tab-item"
          :class="[curr_tab == 2 ? 'active' : '']"
          @click="onTabClick(2)"
        >
          关注店铺
        </div>
        <div
          :class="['tab-item', { active: curr_tab == 3 }]"
          @click="onTabClick(3)"
        >
          帖子收藏
        </div>
        <div
          :class="['tab-item', { active: curr_tab == 4 }]"
          @click="onTabClick(4)"
        >
          面料收藏
        </div>
        <div
          :class="['tab-item', { active: curr_tab == 5 }]"
          @click="onTabClick(5)"
        >
          辅料收藏
        </div>
      </div>
      <div class="search-batch-box">
        <div class="search-box">
          <input
            v-model="query.keyword"
            placeholder="搜索关键词搜索"
            type="text"
            @keyup.enter="getInfiniteList(true)"
          />
          <img
            src="../../assets/images/icon-search-workbench.png"
            @click="getInfiniteList(true)"
          />
        </div>
        <div class="batch-box">
          <template v-if="is_batch">
            <Checkbox :value="select_all" @on-change="onCheckAll"
              >全选</Checkbox
            >
            <div class="batch-btns">
              <template v-if="curr_tab == 1">
                <div class="batch-delete" @click="onBatchCancelCollect">
                  删除
                </div>
                <div class="batch-line">|</div>
                <div class="batch-addcart" @click="onBatchAddCart">
                  加入购物车
                </div>
              </template>
              <template v-else-if="curr_tab == 3">
                <div class="batch-unfollow" @click="onBatchUnfollow">取消关注</div>
              </template>
              <template v-else>
                <div class="batch-unfollow" @click="onBatchCancelFabricAccessory">
                  取消收藏
                </div>
              </template>
            </div>
          </template>
          <div class="batch-btn" @click="is_batch = !is_batch">
            {{ is_batch ? "退出管理" : "批量管理" }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="cate-chips-box"
      v-if="(curr_tab == 4 || curr_tab == 5) && cate_chips.length > 0"
    >
      <div
        class="cate-chips"
        :class="{ collapsed: !cate_expand }"
        ref="cateChips"
      >
        <div
          v-for="chip in cate_chips"
          :key="chip.id"
          :class="[
            'chip',
            {
              active:
                (curr_tab == 4
                  ? query.fabric_category_id || 0
                  : query.accessory_category_id || 0) == chip.id,
            },
          ]"
          @click="onCateChipClick(chip.id)"
        >
          {{ chip.name }}({{ chip.count }})
        </div>
      </div>
      <div
        class="cate-expand-btn"
        v-if="cate_overflow"
        @click="toggleCateExpand"
      >
        {{ cate_expand ? "收起" : "展开" }}
        <Icon :type="cate_expand ? 'ios-arrow-up' : 'ios-arrow-down'" />
      </div>
    </div>
    <div
      class="goods-list-wraper"
      v-if="infiniteList.length > 0 && curr_tab == 1"
    >
      <div
        class="goods-item"
        v-for="(item, index) in infiniteList"
        :key="index"
        @click="onDetailClick(item.product)"
      >
        <div class="goods-cover">
          <img :src="item.product.image | default_img(false)" alt="" class="" />
          <template v-if="!is_batch">
            <div
              class="trash-btn"
              @click.stop="onCollectProduct(item.product.uuid, item.is_available,item.id, index)"
            >
              <img
                src="@/assets/images/icon-mall-collect-trash.png"
                alt=""
                class="trash-icon"
              />
            </div>
            <div class="bottom-btn-box">
              <div
                class="btn-item"
                @click.stop="
                  $router.push({
                    name: 'ShopHome',
                    query: { uid: item.productOwner.code },
                  })
                "
              >
                进入店铺
              </div>
              <span v-if="false">|</span>
              <div v-if="false" class="btn-item">加入购物车</div>
            </div>
          </template>
          <div v-if="is_batch" class="batch-selection">
            <Checkbox
              class="check-box"
              size="large"
              :value="selected_list.includes(item.product.uuid)"
              @click.stop.native.prevent="onBatchSelect(item)"
            ></Checkbox>
          </div>
        </div>
        <div class="goods-title">{{ item.product.name }}</div>
        <div class="goods-price">¥{{ item.product.sale_price }}</div>
        <div class="goods-author">
          <img
            :src="item.productOwner.avatar | default_img"
            alt=""
            class="avatar"
          />
          <div class="nickname">{{ item.productOwner.nickname || "匿名" }}</div>
          <div class="line">|</div>
          <div class="count-num">作品:{{ item.productOwner.works || "0" }}</div>
        </div>
      </div>
    </div>
    <div
      class="shop-list-wrapper"
      v-if="infiniteList.length > 0 && curr_tab == 2"
    >
      <div class="shop-list-item" v-for="(item, index) in 5" :key="index">
        <div class="check-shop" v-if="is_batch">
          <Checkbox
            @click.stop.prevent.native="onBatchSelect(item)"
            :value="selected_list.includes(item.uuid)"
            size="large"
          />
        </div>
        <div class="item-wrapper">
          <div class="item-left">
            <img :src="'' | default_img" alt="" class="avatar" />
            <div class="shop-name">店铺名称店铺名称123123</div>
            <div class="shop-desc">服装设计师|高级定制</div>
            <div class="count-num">作品数:888</div>
            <div class="shop-btn-box">
              <div :class="['btn-item', { 'un-follow': index % 2 == 0 }]">
                <img
                  v-if="index % 2 != 0"
                  src="@/assets/images/icon-mall-liked.png"
                  alt=""
                  class="btn-icon"
                />
                <img
                  v-else
                  src="@/assets/images/icon-mall-unlike.png"
                  alt=""
                  class="btn-icon"
                />
                {{ index % 2 == 0 ? "关注" : "取消关注" }}
              </div>
              <div class="btn-item">
                <img
                  src="@/assets/images/icon-mall-store.png"
                  alt=""
                  class="btn-icon"
                />
                进店
              </div>
            </div>
          </div>
          <div class="item-right">
            <div class="right-items" v-for="(item, index) in 5" :key="index">
              <div class="product-cover">
                <img :src="'' | default_img" alt="" />
              </div>
              <div class="product-title">
                这是一个商品名这是一个商品名这是一个商品名这是一个商品名
              </div>
              <div class="product-price">¥888.88</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="fa-list"
      v-if="infiniteList.length > 0 && (curr_tab == 4 || curr_tab == 5)"
    >
      <div
        class="fa-item"
        v-for="(item, index) in infiniteList"
        :key="index"
        @click="!is_batch && openFabricAccessoryDetail(item)"
      >
        <div class="fa-cover">
          <img :src="item.image | default_img(false)" alt="" />
          <template v-if="!is_batch">
            <div
              class="remove-collect"
              @click.stop="onFabricAccessoryCancel(item, index)"
            >
              取消收藏<Icon type="md-close"></Icon>
            </div>
          </template>
          <div v-if="is_batch" class="batch-selection">
            <Checkbox
              class="check-box"
              size="large"
              :value="selected_list.includes(item.id)"
              @click.stop.native.prevent="onBatchSelect(item)"
            ></Checkbox>
          </div>
        </div>
        <div class="fa-name">{{ faDisplay(item).name }}</div>
      </div>
    </div>
    <div
      v-if="infiniteList.length > 0 && curr_tab == 3"
      class="masonry-container"
      style="margin-top: 30px; padding-bottom: 70px"
    >
      <masonry
        ref="masonryWall"
        :cols="{ default: 6, 1600: 5, 1300: 4, 1000: 3, 700: 2 }"
        :gutter="{ default: '30px', 1300: '20px', 700: '15px', 400: '10px' }"
      >
        <div
          v-for="(item, index) in infiniteList"
          :key="index"
          @click.prevent.stop="onArticleDetail(item)"
        >
          <template>
            <div class="masonry-item">
              <img
                v-if="item.type == 2"
                src="../../assets/images/icon-play.png"
                class="play-btn"
                alt=""
              />
              <!-- <img src="../../assets/images/icon-match-on-list.png" class="match-ico" /> -->
              <div
                class="remove-collect"
                @click.prevent.stop="onCollectRemove(item)"
              >
                移除<Icon type="md-close"></Icon>
              </div>
              <div class="img-container">
                <img
                  :src="item.cover"
                  @load="onImageLoad"
                  class="masonry-image"
                />
              </div>
              <div class="item-content">
                <div class="title">{{ item.title }}</div>
                <div class="bottom-box">
                  <div class="bottom-item">
                    <img
                      src="@/assets/images/icon-views-workbench-list.png"
                    />
                    <div style="margin-left: 3px">{{ item.view_times }}</div>
                  </div>
                  <div class="bottom-item">
                    <img
                      src="@/assets/images/icon-comment-workbench-list.png"
                    />
                    <div style="margin-left: 3px">
                      {{ item.comment_count }}
                    </div>
                  </div>
                  <div class="bottom-item">
                    <img
                      src="@/assets/images/icon-collect-workbench-list.png"
                    />
                    <div style="margin-left: 3px">{{ item.zan_count }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </masonry>
    </div>
    <empty
      v-if="infiniteList.length == 0 || !infiniteList.length"
      :emptyType="curr_tab == 1 ? 'product' : 'shop'"
      :emptyText="empty_text"
      :emptyTips="empty_tips"
      :marginTop="50"
      :bottomBtn="empty_btn"
      :routeName="empty_route"
    />
    <ArticleDetail
      ref="articleDetail"
      v-if="show_detail"
      @on-close="onCloseArticleDetail"
      :uuid="article_id"
    ></ArticleDetail>
  </div>
</template>
<script>
import {
  CartBatchAdd,
  CollectBatchCancel,
  collectProductList,
  productCollect,
  FabricCollectList,
  AccessoryCollectList,
  FabricBatchCollect,
  AccessoryBatchCollect,
  CollectFabric,
  CollectAccessory,
  FabricCategoryList,
  AccessoryCategoryList,
} from "@/api/index";
import { GetMyCollectList, PostsCollect } from "@/api/social";
import ArticleDetail from "@/components/ArticleDetail";
import Empty from "@/components/Empty.vue";
import infinite from "@/mixins/infinite";
export default {
  components: { Empty,ArticleDetail },
  mixins: [infinite],
  data() {
    return {
      curr_tab: 1,
      query: {
        keyword: "",
        fabric_category_id: "",
        accessory_category_id: "",
      },
      fabric_category_list: [],
      accessory_category_list: [],
      fabric_category_counts: {},
      fabric_all_count: 0,
      accessory_category_counts: {},
      accessory_all_count: 0,
      cate_expand: false,
      cate_overflow: false,
      selected_list: [],
      is_batch: false,
      // select_all:false,
      isBackToTopVisible: false,
      article_id:'',
      show_detail:false
    };
  },
  computed: {
    select_all() {
      return (
        this.selected_list.length === this.infiniteList.length &&
        this.selected_list.length > 0
      );
    },
    empty_text(){
        const {curr_tab} = this;
        switch(Number(curr_tab)){
            case 1:
                return "收藏夹空空的";
            case 2:
                return "您还没关注过任何店铺哦~";
            default:
                return "收藏夹空空的";
        }
    },
    empty_tips(){
        const {curr_tab} = this;
        switch(Number(curr_tab)){
            case 1:
                return "快去设计师商城挑选心仪穿搭,把美好穿搭存起来~";
            case 2:
                return "逛设计师商城,发现心仪好店,一键关注锁定上新与福利";
            case 4:
                return "还没有收藏的面料,快去面料馆挑选心仪面料吧~";
            case 5:
                return "还没有收藏的辅料,快去辅料库挑选心仪辅料吧~";
            default:
                return "还没有收藏过帖子哦~";
        }

    },
    empty_btn() {
        const { curr_tab } = this;
        switch (Number(curr_tab)) {
            case 1:
                return "去设计师商城逛逛";
            case 3:
                return "去社区逛逛";
            case 4:
                return "去面料馆逛逛";
            case 5:
                return "去辅料库逛逛";
            default:
                return "去设计师商城逛逛";
        }
    },
    empty_route() {
        const { curr_tab } = this;
        switch (Number(curr_tab)) {
            case 1:
                return "Mall";
            case 3:
                return "Posts";
            case 4:
            case 5:
                return "FabricHall";
            default:
                return "Mall";
        }
    },
    cate_chips() {
      if (this.curr_tab === 4) {
        return this.buildChips(
          this.fabric_category_list,
          "fabric_category_id",
          this.fabric_category_counts,
          this.fabric_all_count
        );
      }
      if (this.curr_tab === 5) {
        return this.buildChips(
          this.accessory_category_list,
          "accessory_category_id",
          this.accessory_category_counts,
          this.accessory_all_count
        );
      }
      return [];
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.checkCateOverflow);
    this.getFabricCategoryList();
    this.getAccessoryCategoryList();
    this.getInfiniteList(true);
    this.$nextTick(this.checkCateOverflow);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.checkCateOverflow);
  },
  created() {},
  watch: {
    cate_chips() {
      this.cate_expand = false;
      this.$nextTick(this.checkCateOverflow);
    },
    curr_tab() {
      this.cate_expand = false;
      this.$nextTick(this.checkCateOverflow);
    },
  },
  methods: {
    onCloseArticleDetail(){
      this.show_detail = false;
    },
     async onCollectRemove(item) {
      console.log("remove-item", item);
      try {
        await PostsCollect({ uuid: item.uuid });
        this.$layer.msg("取消收藏成功");
        this.getInfiniteList(true);
      } catch (e) {
        console.log("取消收藏异常", e);
      }
    },
    onArticleDetail(item) {
      console.log("aaa-click", item);
      this.article_id = item.uuid;
      this.show_detail = true;
    },
    onImageLoad() {
      this.$nextTick(() => {
        this.$refs.masonryWall?.reCalculate();
      });
    },
    async onBatchCancelCollect() {
      try {
        const param = {};
        param.uuid = this.selected_list;
        const { code, msg } = await CollectBatchCancel(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg("操作成功~");
        this.getInfiniteList(true);
        this.selected_list = [];
        this.is_batch = false;
      } catch (e) {
        console.log("err-onBatchCancelCollect", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onBatchAddCart() {
      try {
        const param = {};
        param.uuid = this.selected_list;
        const { code, msg } = await CartBatchAdd(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg("操作成功~");
        this.getInfiniteList(true);
        this.selected_list = [];
        this.is_batch = false;
      } catch (e) {
        console.log("err-onBatchAddCart", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    onCheckAll() {
      console.log("checkAll");
      if (
        this.selected_list.length === this.infiniteList.length &&
        this.selected_list.length > 0
      ) {
        console.log("uncheckAll");
        this.selected_list = [];
        return;
      }
      console.log("check_all");
      this.selected_list = [];
      this.infiniteList.forEach((item) => {
        this.selected_list.push(this.curr_tab === 1 ? item.product.uuid : item.id);
      });
    },
    onDetailClick({ uuid }) {
      this.$router.push({ name: "GoodsDetail", params: { uuid } });
    },
    // 面料/辅料收藏项点击：新浏览器标签页打开详情页
    openFabricAccessoryDetail(item) {
      const type = this.curr_tab === 4 ? "fabric" : "accessory";
      const url = `/fabricHallDetail?id=${item.id}&type=${type}`;
      window.open(url, "_blank");
    },
    // 卡片展示字段归一化
    faDisplay(item) {
      if (this.curr_tab === 4) {
        return {
          name: item.fabric_name_cn,
          sub: item.category_name || "",
        };
      }
      return {
        name: item.accessory_name,
        sub:
          "编号: " +
          (item.accessory_sku || "") +
          (item.spec ? " / " + item.spec : ""),
      };
    },
    // 单个取消收藏（hover 取消关注）
    async onFabricAccessoryCancel(item, index) {
      const api = this.curr_tab === 4 ? CollectFabric : CollectAccessory;
      try {
        await api({ id: item.id, is_collect: 0 });
        this.$layer.msg("取消收藏成功");
        // 整体刷新，保证分类计数与收藏数据一致
        this.getInfiniteList(true);
      } catch (e) {
        console.log("err-onFabricAccessoryCancel", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async getFabricCategoryList() {
      try {
        const { data } = await FabricCategoryList();
        this.fabric_category_list = data || [];
      } catch (e) {
        console.log("getFabricCategoryList", e);
      }
    },
    async getAccessoryCategoryList() {
      try {
        const { data } = await AccessoryCategoryList();
        this.accessory_category_list = data || [];
      } catch (e) {
        console.log("getAccessoryCategoryList", e);
      }
    },
    // 构建分类 chip（仅展示已收藏的分类项 + 全部）
    buildChips(list, idKey, counts, allCount) {
      const chips = [];
      const total = allCount || 0;
      if (total > 0) {
        chips.push({ id: 0, name: "全部", count: total });
      }
      (list || []).forEach((p) => {
        const items = p.children && p.children.length ? p.children : [p];
        items.forEach((c) => {
          if (c.category_name === "全部") return;
          const id = c[idKey];
          const cnt = (counts && counts[id]) || 0;
          if (cnt <= 0) return; // 未收藏的分类不展示
          chips.push({ id, name: c.category_name, count: cnt });
        });
      });
      return chips;
    },
    // 点击分类 chip 过滤
    onCateChipClick(id) {
      if (this.curr_tab === 4) {
        this.query.fabric_category_id = id;
      } else {
        this.query.accessory_category_id = id;
      }
      this.getInfiniteList(true);
    },
    // 检测分类 chip 是否超出单行（决定是否显示展开/收起）
    checkCateOverflow() {
      const el = this.$refs.cateChips;
      if (!el || this.cate_expand) return;
      this.cate_overflow = el.scrollHeight > el.clientHeight + 1;
    },
    // 切换分类展开/收起
    toggleCateExpand() {
      this.cate_expand = !this.cate_expand;
      if (!this.cate_expand) {
        this.$nextTick(this.checkCateOverflow);
      }
    },
    // 批量取消收藏（面料/辅料）
    async onBatchCancelFabricAccessory() {
      if (!this.selected_list.length) {
        this.$layer.msg("请先选择要取消收藏的项");
        return;
      }
      try {
        const api =
          this.curr_tab === 4 ? FabricBatchCollect : AccessoryBatchCollect;
        const { code, msg } = await api({ ids: this.selected_list });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        this.$layer.msg("操作成功~");
        this.getInfiniteList(true);
        this.selected_list = [];
        this.is_batch = false;
      } catch (e) {
        console.log("err-onBatchCancelFabricAccessory", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    handleScroll: _.debounce(function () {
      this.isBackToTopVisible = window.pageYOffset > 300; // 滚动超过 300px 显示

      console.log("111");
      // 触底加载逻辑
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      if (
        scrollTop + windowHeight >= documentHeight - 100 &&
        !this.infiniteEnded
      ) {
        this.getInfiniteList();
      }
    }, 200),
    async onCollectProduct(uuid, is_available,id, index) {
      try {
        const { code, msg } = await productCollect({ uuid, is_available,id });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        // this.product_list[index].is_collected = !this.product_list[index].is_collected;
        this.$layer.msg("操作成功~");
        this.getInfiniteList(true);
      } catch (e) {
        console.log("err-collect", e);
      }
    },
    onBatchSelect(item) {
      const key = this.curr_tab === 1 ? item.product.uuid : item.id;
      if (this.selected_list.includes(key)) {
        this.selected_list = this.selected_list.filter((v) => v !== key);
      } else {
        this.selected_list.push(key);
      }
    },
    onTabClick(type) {
      this.curr_tab = type;
      this.selected_list = [];
      this.getInfiniteList(true);
    },
    async getInfiniteData(pageIndex, pageSize) {
      try {
        if (this.curr_tab === 1) {
          const { code, msg, data } = await collectProductList({
            page: pageIndex,
            limit: pageSize,
            keyword: this.query.keyword,
          });
          if (code > 0) {
            this.$layer.msg(msg);
            return;
          }
          console.log("data", data);
          return { data: data.list || [] };
        } else if (this.curr_tab === 4) {
          const { code, msg, data } = await FabricCollectList({
            page: pageIndex,
            size: pageSize,
            keyword: this.query.keyword,
            fabric_category_id: this.query.fabric_category_id || 0,
          });
          if (code > 0) {
            this.$layer.msg(msg);
            return;
          }
          this.fabric_category_counts = data.category_counts || {};
          this.fabric_all_count = data.all_count || 0;
          return { data: data.list || [] };
        } else if (this.curr_tab === 5) {
          const { code, msg, data } = await AccessoryCollectList({
            page: pageIndex,
            size: pageSize,
            keyword: this.query.keyword,
            accessory_category_id: this.query.accessory_category_id || 0,
          });
          if (code > 0) {
            this.$layer.msg(msg);
            return;
          }
          this.accessory_category_counts = data.category_counts || {};
          this.accessory_all_count = data.all_count || 0;
          return { data: data.list || [] };
        } else {
          const { keyword } = this.query;
          const { data } = await GetMyCollectList({
            page: pageIndex,
            limit: pageSize,
            keyword,
          });
          const res = {};
          if (!data) {
            res.data = [];
            return res;
          }
          this.collect_count = data.count;
          res.data = data.list ? data.list : [];
          console.log("res", res);
          return res;
        }
      } catch (e) {
        console.log("get-collect-product-list", e);
        return [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mall-collect {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding: 20px 20px 180px 30px;
  user-select: none;
  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #d6d6d6;
    padding-bottom: 10px;
    position: relative;
    z-index: 1;

    .tabs {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .tab-item {
        cursor: pointer;
        color: #666666;
        font-size: 18px;
        margin-right: 50px;
        position: relative;
        z-index: 2;

        &.active {
          color: #000000;
          font-weight: bold;

          &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: -22px;
            width: 100%;
            height: 3px;
            background: #ff5967;
            z-index: 3;
            pointer-events: none;
          }
        }
      }

      .tab-item.active {
        border-bottom: none !important;
      }
    }

    .search-batch-box {
      display: flex;
      align-items: center;
      column-gap: 39px;
      .search-box {
        background: #f3f4f6;
        border-radius: 25px;
        width: 300px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        input {
          flex: 1;
          border: none;
          outline: none;
          background: transparent;
          padding-left: 20px;
        }

        img {
          width: 21px;
          height: 21px;
          margin-right: 20px;
          cursor: pointer;
        }
      }
      .batch-box {
        display: flex;
        align-items: center;
        column-gap: 25px;
        .batch-btns {
          display: flex;
          align-items: center;
          column-gap: 10px;
          .batch-unfollow,
          .batch-delete,
          .batch-addcart {
            color: #333333;
            font-size: 14px;
            cursor: pointer;
          }
          .batch-line {
            font-size: 14px;
            color: #cccccc;
          }
        }
        .batch-btn {
          color: #666666;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
        }
      }
    }
  }
  .cate-chips-box {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 20px;
    .cate-chips {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      &.collapsed {
        max-height: 44px;
        overflow: hidden;
      }
      .chip {
        height: 32px;
        line-height: 32px;
        padding: 0 12px;
        border-radius: 6px;
        // background: #f3f4f6;
        color: #666666;
        font-size: 14px;
        cursor: pointer;
        white-space: nowrap;
        transition: all 0.15s;
        &.active {
          background: #ff5967;
          color: #ffffff;
          font-weight: bold;
        }
      }
    }
    .cate-expand-btn {
      flex: 0 0 auto;
      height: 30px;
      padding: 0 12px;
      border-radius: 4px;
      background: #f3f4f6;
      color: #666666;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 4px;
      cursor: pointer;
      white-space: nowrap;
      &:hover {
        color: #ff5967;
      }
    }
  }
  .goods-list-wraper {
    width: 100%;
    margin-top: 28px;
    display: flex;
    flex-wrap: wrap;
    gap: 25px;
    .goods-item {
      width: calc(100% / 5 - 25px);
      background: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: stretch;

      .goods-cover {
        width: 100%;
        height: 378px;
        min-height: 0;
        border-radius: 6px;
        background: #f5f5f5;
        overflow: hidden;
        position: relative;
        display: flex;

        img {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 6px;
          object-fit: contain;
        }

        .trash-btn {
          display: none;
          position: absolute;
          top: 0;
          right: 0;
          font-size: 12px;
          align-items: center;
          cursor: pointer;
          max-height: 32px;

          .trash-icon {
            width: 40px;
            height: 40px;
          }
        }

        .bottom-btn-box {
          position: absolute;
          width: 100%;
          height: 46px;
          background: rgba(0, 0, 0, 0.5);
          bottom: 0;
          left: 0;
          display: none;
          align-items: center;
          justify-content: space-between;
          color: #ffffff;
          .btn-item {
            flex: 1;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
          }
          span {
            text-align: center;
            color: #4d4d4d;
          }
        }

        .batch-selection {
          position: absolute;
          top: 10px;
          left: 10px;
          display: inline-block;
          .check-box {
            width: 24px;
            height: 24px;
          }
        }

        .remove-collect {
          display: none;
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.4);
          color: white;
          font-size: 14px;
          line-height: normal;
          padding: 4px 14px;
          border-bottom-right-radius: 10px;
          border-top-left-radius: 10px;
          align-items: center;
          z-index: 10;
          cursor: pointer;
        }
        &:hover {
          .bottom-btn-box {
            display: flex;
          }
          .trash-btn {
            display: flex;
          }
          .remove-collect {
            display: flex;
          }
        }
      }

      .goods-title {
        // margin-top:20px;
        line-height: 35.81px;
        color: #1a1a1a;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .goods-price {
        line-height: 35.81px;
        color: #1a1a1a;
        font-size: 18px;
        font-weight: bold;
      }

      .goods-sub {
        line-height: 24px;
        color: #999999;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .goods-author {
        display: flex;
        align-items: center;
        width: 100%;
        .avatar {
          width: 25px;
          height: 25px;
          border-radius: 50%;
          margin-right: 9px;
        }

        .line {
          margin: 0 9px;
          font-size: 13px;
        }

        .nickname,
        .count-num {
          flex: 0 0 1;
          color: #666666;
          font-size: 13px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .fa-list {
    width: 100%;
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 16px 12px;
    .fa-item {
      width: 208px;
      cursor: pointer;
      .fa-cover {
        width: 208px;
        height: 208px;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        background: #f5f5f5;
        img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }
        .remove-collect {
          display: none;
          position: absolute;
          top: 8px;
          right: 8px;
          background: rgba(0, 0, 0, 0.4);
          color: #ffffff;
          font-size: 13px;
          line-height: normal;
          padding: 4px 12px;
          border-radius: 14px;
          align-items: center;
          z-index: 10;
          cursor: pointer;
          i {
            margin-left: 2px;
          }
        }
        .batch-selection {
          position: absolute;
          top: 10px;
          left: 10px;
          .check-box {
            width: 24px;
            height: 24px;
          }
        }
        &:hover {
          .remove-collect {
            display: flex;
          }
        }
      }
      .fa-name {
        width: 208px;
        margin-top: 10px;
        font-size: 14px;
        line-height: 20px;
        color: #1a1a1a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .shop-list-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 19px;
    margin-top: 72px;
    .shop-list-item {
      width: 100%;
      border: 1px solid #e0e0e0;
      border-radius: 6px;
      position: relative;
      .check-shop {
        position: absolute;
        top: 20px;
        left: 20px;
      }
      .item-wrapper {
        display: flex;
        align-items: center;
        .item-left {
          width: 100%;
          max-width: 346px;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          align-items: center;
          justify-content: center;
          padding: 39px 0 46px 0;
          .avatar {
            width: 88px;
            height: 88px;
            background: #ebebeb;
            border: 1px solid #cccccc;
            border-radius: 10px;
            margin-bottom: 30px;
          }
          .shop-name {
            color: #1a1a1a;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 16px;
          }
          .shop-desc {
            color: #666666;
            font-size: 14px;
            margin-bottom: 27px;
          }
          .count-num {
            color: #666666;
            font-size: 14px;
            margin-bottom: 47px;
          }
          .shop-btn-box {
            display: flex;
            align-items: center;
            column-gap: 10px;
            .btn-item {
              width: 110px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              column-gap: 3px;
              color: #333333;
              font-size: 13px;
              border-radius: 6px;
              border: 1px solid #e0e0e0;
              cursor: pointer;
              .btn-icon {
                width: 22px;
                height: 22px;
              }
              &.un-follow {
                background: #ff5967;
                color: #ffffff;
              }
            }
          }
        }
        .item-right {
          flex: 1;
          height: 100%;
          padding: 20px;
          border-left: 1px solid #e0e0e0;
          display: flex;
          align-items: center;
          column-gap: 17px;
          overflow: hidden;
          .right-items {
            display: flex;
            flex-direction: column;
            row-gap: 14px;
            width: calc(100% / 5 - 17px);
            .product-cover {
              width: 100%;
              height: 280px;
              background: #f5f5f5;
              border-radius: 6px;
              overflow: hidden;
              display: flex;
              align-items: center;
              img {
                width: 100%;
                height: auto;
                object-fit: cover;
              }
            }
            .product-title {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #1a1a1a;
              font-size: 14px;
              font-weight: 400;
            }
            .product-price {
              color: #1a1a1a;
              font-size: 18px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  /**瀑布流样式开始 */
.masonry-container {
  max-width: 1520px;
  margin: 0 auto;
  .masonry-item {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 30px;
    width: 100%;
    cursor: pointer;
    position: relative;
    .remove-collect {
      display: none;
    }
    &:hover .remove-collect {
      position: absolute;
      background: rgba(0, 0, 0, 0.4);
      color: white;
      font-size: 14px;
      line-height: normal;
      padding: 4px 14px;
      border-bottom-right-radius: 10px;
      border-top-left-radius: 10px;
      display: flex;
      align-items: center;
      z-index: 10;
    }
    .play-btn {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 10px;
      right: 10px;
    }
    .match-ico {
      position: absolute;
      width: 32px;
      height: 32px;
      right: 10px;
      bottom: 100px;
    }

    .img-container {
      position: relative;
      display: block;
      width: 100%;
      img {
        display: block;
        width: 100%;
        height: auto;
      }

      &:hover::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(128, 128, 128, 0.4);
        pointer-events: none;
        border-radius: 10px;
      }

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(128, 128, 128, 0.05);
        pointer-events: none;
        border-radius: 10px;
      }

      .masonry-image {
        width: 100%;
        display: block;
        object-fit: contain;
        border-radius: 10px;
      }
    }

    .item-content {
      padding: 15px 5px;
      .title {
        font-size: 16px;
        color: #000000;
      }
      .bottom-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;

        .bottom-item {
          display: flex;
          align-items: center;
          &:nth-child(2) {
            margin-left: 10px;
            margin-right: 10px;
          }
          img {
            width: 20px;
            height: 20px;
          }
        }

        .views-box {
          display: flex;
          align-items: center;
        }

        .comment-box {
          display: flex;
          align-items: center;
        }

        .like-box {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
/**瀑布流样式结束 */
}

/* 屏幕宽度在 1280px 到 1679px 之间 */
@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .mall-collect {
    padding: 16px 16px 144px 24px;

    .top {
      padding-bottom: 8px;

      .tabs {
        .tab-item {
          font-size: 15px;
          margin-right: 40px;

          &.active::after {
            bottom: -18px;
            height: 2px;
          }
        }
      }

      .search-batch-box {
        column-gap: 31px;

        .search-box {
          width: 240px;
          height: 40px;
          border-radius: 20px;

          input {
            padding-left: 16px;
          }

          img {
            width: 17px;
            height: 17px;
            margin-right: 16px;
          }
        }

        .batch-box {
          column-gap: 20px;

          .batch-btns {
            column-gap: 8px;

            .batch-unfollow,
            .batch-delete,
            .batch-addcart {
              font-size: 11px;
            }

            .batch-line {
              font-size: 11px;
            }
          }

          .batch-btn {
            font-size: 11px;
          }
        }
      }
    }

    .goods-list-wraper {
      margin-top: 22px;
      gap: 20px;

      .goods-item {
        width: calc(100% / 5 - 20px);

        .goods-cover {
          height: 302px;
          border-radius: 5px;

          .trash-icon {
            width: 32px;
            height: 32px;
          }

          .bottom-btn-box {
            height: 37px;

            .btn-item {
              font-size: 11px;
            }
          }

          .batch-selection {
            .check-box {
              width: 19px;
              height: 19px;
            }
          }
        }

        .goods-title {
          line-height: 29px;
          font-size: 13px;
        }

        .goods-price {
          line-height: 29px;
          font-size: 14px;
        }

        .goods-author {
          .avatar {
            width: 20px;
            height: 20px;
            margin-right: 7px;
          }

          .line {
            margin: 0 7px;
            font-size: 10px;
          }

          .nickname,
          .count-num {
            font-size: 10px;
          }
        }
      }
    }

    .shop-list-wrapper {
      row-gap: 15px;
      margin-top: 58px;

      .shop-list-item {
        border-radius: 5px;

        .check-shop {
          top: 16px;
          left: 16px;
        }

        .item-wrapper {
          .item-left {
            max-width: 277px;
            padding: 31px 0 37px 0;

            .avatar {
              width: 70px;
              height: 70px;
              border-radius: 8px;
            }

            .shop-name {
              font-size: 14px;
              margin-bottom: 13px;
            }

            .shop-desc {
              font-size: 11px;
              margin-bottom: 22px;
            }

            .count-num {
              font-size: 11px;
              margin-bottom: 38px;
            }

            .shop-btn-box {
              column-gap: 8px;

              .btn-item {
                width: 88px;
                height: 32px;
                font-size: 10px;
                border-radius: 5px;

                .btn-icon {
                  width: 18px;
                  height: 18px;
                }
              }
            }
          }

          .item-right {
            padding: 16px;
            column-gap: 14px;

            .right-items {
              row-gap: 11px;
              width: calc(100% / 5 - 14px);

              .product-cover {
                height: 224px;
                border-radius: 5px;
              }

              .product-title {
                font-size: 11px;
              }

              .product-price {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
  /**瀑布流样式开始 */
    .masonry-container {
      max-width: 1368px;
    }
}

/* 屏幕宽度小于等于 1279px */
@media screen and (max-width: 1279px) {
  .mall-collect {
    padding: 12px 12px 108px 18px;

    .top {
      padding-bottom: 6px;

      .tabs {
        .tab-item {
          font-size: 13px;
          margin-right: 30px;

          &.active::after {
            bottom: -13px;
            height: 2px;
          }
        }
      }

      .search-batch-box {
        column-gap: 23px;

        .search-box {
          width: 180px;
          height: 30px;
          border-radius: 15px;

          input {
            padding-left: 12px;
          }

          img {
            width: 13px;
            height: 13px;
            margin-right: 12px;
          }
        }

        .batch-box {
          column-gap: 15px;

          .batch-btns {
            column-gap: 6px;

            .batch-unfollow,
            .batch-delete,
            .batch-addcart {
              font-size: 8px;
            }

            .batch-line {
              font-size: 8px;
            }
          }

          .batch-btn {
            font-size: 8px;
          }
        }
      }
    }

    .goods-list-wraper {
      margin-top: 17px;
      gap: 15px;

      .goods-item {
        width: calc(100% / 5 - 15px);

        .goods-cover {
          height: 227px;
          border-radius: 4px;

          .trash-icon {
            width: 24px;
            height: 24px;
          }

          .bottom-btn-box {
            height: 28px;

            .btn-item {
              font-size: 8px;
            }
          }

          .batch-selection {
            .check-box {
              width: 14px;
              height: 14px;
            }
          }
        }

        .goods-title {
          line-height: 21px;
          font-size: 10px;
        }

        .goods-price {
          line-height: 21px;
          font-size: 11px;
        }

        .goods-author {
          .avatar {
            width: 15px;
            height: 15px;
            margin-right: 5px;
          }

          .line {
            margin: 0 5px;
            font-size: 8px;
          }

          .nickname,
          .count-num {
            font-size: 8px;
          }
        }
      }
    }

    .shop-list-wrapper {
      row-gap: 11px;
      margin-top: 43px;

      .shop-list-item {
        border-radius: 4px;

        .check-shop {
          top: 12px;
          left: 12px;
        }

        .item-wrapper {
          .item-left {
            max-width: 208px;
            padding: 23px 0 28px 0;

            .avatar {
              width: 53px;
              height: 53px;
              border-radius: 6px;
            }

            .shop-name {
              font-size: 11px;
              margin-bottom: 10px;
            }

            .shop-desc {
              font-size: 8px;
              margin-bottom: 16px;
            }

            .count-num {
              font-size: 8px;
              margin-bottom: 28px;
            }

            .shop-btn-box {
              column-gap: 6px;

              .btn-item {
                width: 66px;
                height: 24px;
                font-size: 8px;
                border-radius: 4px;

                .btn-icon {
                  width: 13px;
                  height: 13px;
                }
              }
            }
          }

          .item-right {
            padding: 12px;
            column-gap: 10px;

            .right-items {
              row-gap: 8px;
              width: calc(100% / 5 - 10px);

              .product-cover {
                height: 168px;
                border-radius: 4px;
              }

              .product-title {
                font-size: 8px;
              }

              .product-price {
                font-size: 11px;
              }
            }
          }
        }
      }
    }
  }
  /**瀑布流样式开始 */
    .masonry-container {
      max-width: 1216px;
      .masonry-item {
        margin-bottom: 20px;
        .remove-collect {
          display: none;
        }
        &:hover .remove-collect {
          font-size: 12px;
          padding: 3px 11px;
        }
        .play-btn {
          width: 24px;
          height: 24px;
          top: 8px;
          right: 8px;
        }
        .match-ico {
          width: 26px;
          height: 26px;
          right: 8px;
          bottom: 80px;
        }
        .item-content {
          padding: 12px 4px;
          .title {
            font-size: 14px;
          }
          .bottom-box {
            margin-top: 8px;
            .bottom-item {
              &:nth-child(2) {
                margin-left: 8px;
                margin-right: 8px;
              }
              img {
                width: 16px;
                height: 16px;
              }
            }
          }
        }
      }
    }
}

::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #ff5967;
  background-color: #ff5967;
}


</style>
